import React, { useState, useEffect  } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { useAuth } from "../../Context/AuthContext";
import { toast } from "react-toastify";
import "./Profile.css";  // 👈 חיבור לקובץ ה־CSS החדש

const API = process.env.REACT_APP_API;

const Profile = () => {
  const navigate = useNavigate();

  const { user, setUser, token } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  // שליפה מהשרת ברגע שהעמוד נטען
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${API}/api/users/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "שגיאה בטעינת פרופיל");

        // ממלא את הטופס בפרטי המשתמש
        setPhone(data.phone || "");
      } catch (err) {
            toast.error(err.message);
      }
    };

    if (token) {
        fetchProfile();
    }
  }, [token]);


  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!/^0\d{9}$/.test(phone)) {
      toast.error("מספר טלפון לא חוקי. חייב להיות 10 ספרות ומתחיל ב-0");
      return;
    }

    try {
      const { data } = await axios.put(
      `${API}/api/users/me`,
      { name, email, password, phone},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setUser(data);
      toast.success("הפרטים עודכנו בהצלחה");
      navigate("/")
    } catch (err) {
        toast.error(err.message);
    }
  };

  if (!user) {
    return <p className="profile-error">חייבים להתחבר כדי לראות את הפרופיל</p>;
  }

  return (
    <div className="profile-container">
        <div className="home-icon" onClick={() => navigate("/")}>
            <IoHome title="עמוד הבית" size={30} />
        </div>
      <form onSubmit={handleUpdate} className="profile-form">
        <h2 className="profile-title">פרופיל משתמש</h2>

        <label className="profile-label">שם מלא:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="profile-input"
        />

        <label className="profile-label">דוא"ל:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="profile-input"
        />

        <label className="profile-label">סיסמה חדשה (רשות):</label>
        <input
          type="password"
          placeholder="********"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="profile-input"
        />

        <label className="profile-label">טלפון:</label>
        <input
          type="text"
          value={phone}
          onChange={(e) => {
            const val = e.target.value.replace(/\D/g, ""); // רק ספרות
            if (val.length <= 10) setPhone(val);
          }}
          placeholder="0501234567"
          className="profile-input"
        />

        <button type="submit" className="profile-button">
          עדכון פרטים
        </button>
      </form>
    </div>
  );
};

export default Profile;
